<script>

import Number from "./Number.svelte";

import { menu, step } from "./store.js";

function setQuantity()
{
	if (this.quantity == 0)
	{
		this.quantity++;
	}
	else
	{
		this.quantity = 0;
	}

	$menu = $menu;
}

</script>

<h2 class="text-xl lg:text-3xl font-semibold uppercase tracking-wide lg:leading-tight">{$menu[$step].title}</h2>
<p class="text-lg text-center">{$menu[$step].description}</p>

<div class="flex flex-col gap-2 w-full max-w-[800px]">

	{#each $menu[$step].list as item}
		<div class="flex gap-8 items-center bg-white p-2 px-4">
			<span class=" mr-auto">{item.title}</span>

			<div class="flex gap-1">
				<div class="flex flex-col gap-1 items-end">
				{#each item.sizes as size}
					<div class="flex gap-4 items-center">
						{#if size.quantity > 0 || item.sizes.length == 1}
						<Number min={0} bind:value={size.quantity} />
						<span class:text-primary="{size.quantity > 0}" class="text-dark w-12 text-right">${size.price/100 * (Math.max(1, size.quantity))}</span>
						{:else}
						<span class="text-dark w-24 text-right">${size.price/100}</span>
						{/if}

						{#if item.sizes.length > 1}
						<div on:click="{setQuantity.bind(size)}" class:bg-primary="{size.quantity > 0}" class="cursor-pointer text-sm bg-dark bg-opacity-80 border-0 text-white px-4 py-2">{size.size}</div>
						{/if}
					</div>
				{/each}
				</div>
			</div>

		</div>
	{/each}
</div>
